// extracted by mini-css-extract-plugin
export default {"block":"BlueCircleButton_block__88ubq"};